import {filterBy} from "@progress/kendo-data-query"
import {Field, Form, FormElement} from "@progress/kendo-react-form"
import {Input} from "@progress/kendo-react-inputs"
import {useInternationalization} from "@progress/kendo-react-intl"
import dayjs from "dayjs"
import {MDBCard, MDBCol, MDBRow} from "mdbreact"
import {useEffect, useState} from "react"
import {DvsaFee} from "../../containers/DvsaFees/dvsaFeesSlice"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"

import DvsaFeePricingBody from "./dvsaFeePricingBody"
import DvsaFeeRecord from "./dvsaFeeRecord"

interface FlatDvsaFee extends DvsaFee {
    flatDvsaFee: string | null
}

const DvsaFeeCard = () => {
    const intl = useInternationalization()
    const dvsaFeesData = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaFees)
    const [dvsaFee, setDvsaFee] = useState<FlatDvsaFee[] | null>(null)

    useEffect(() => {
        setDvsaFee(
            dvsaFeesData.map(
                dvsaFee =>
                    ({
                        ...dvsaFee,
                        flatDvsaFee: null,
                    } as FlatDvsaFee),
            ),
        )
    }, [dvsaFeesData])

    const onChangeHandler = (dvsaFeesData: DvsaFee[], event: any) => {
        const formatCurrency = (dayVal: number | null) => intl.formatNumber(dayVal ?? 0, "c").replace(/,/g, "")
        const formatDate = (date: any) => dayjs(date).format("DD/MM/YYYY")
        const formatUpdatedDate = (date: any) => dayjs(date).format("DD/MM/YYYY H:mm")
        const transformedDvsaFee = dvsaFeesData.map(dvsaFee => ({
            ...dvsaFee,
            flatDvsaFee: `
            ${formatCurrency(dvsaFee.dvsaFee)}
            ~${formatCurrency(dvsaFee.dayFee1)}
            ~${formatCurrency(dvsaFee.dayFee2)}
            ~${formatCurrency(dvsaFee.dayFee3)}
            ~${formatCurrency(dvsaFee.dayFee4)}
            ~${formatCurrency(dvsaFee.dayFee5)}
            ~${formatCurrency(dvsaFee.dayFee6)}
            ~${formatDate(dvsaFee.effectiveDate1)}
            ~${formatDate(dvsaFee.effectiveDate2)}
            ~${formatDate(dvsaFee.effectiveDate3)}
            ~${formatDate(dvsaFee.effectiveDate4)}
            ~${formatDate(dvsaFee.effectiveDate5)}
            ~${formatDate(dvsaFee.effectiveDate6)}
            ~${formatUpdatedDate(dvsaFee.updateDate)}`,
        }))
        return setDvsaFee(
            filterBy(transformedDvsaFee, {
                logic: "or",
                filters: [{field: "flatDvsaFee", operator: "contains", value: event.value, ignoreCase: true}],
            }),
        )
    }

    return (
        <>
            <div className="d-flex justify-content-between pb-2">
                <Form
                    render={() => (
                        <FormElement style={{width: 300}}>
                            <fieldset className={"k-form-fieldset"}>
                                <Field
                                    onChange={event => onChangeHandler(dvsaFeesData, event)}
                                    name={"dvsaFeeSearch"}
                                    component={Input}
                                    className="ps-0"
                                    label={"Search"}
                                />
                            </fieldset>
                        </FormElement>
                    )}
                />
            </div>
            <MDBRow className="pe-3">
                {dvsaFee != null &&
                    dvsaFee.map((dvsaCard,index) => (
                        <MDBCol xl="2" lg="3" md="4" sm="6" xs="12" className="pe-0" key={crypto.randomUUID()}>
                            <MDBCard className="mb-3">
                                <DvsaFeePricingBody dvsaCard={dvsaCard} />
                            </MDBCard>
                        </MDBCol>
                    ))}
            </MDBRow>
            <DvsaFeeRecord />
        </>
    )
}

export default DvsaFeeCard
